import { render } from "./Footer.vue?vue&type=template&id=d1964cdc&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=d1964cdc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1964cdc"]])

export default __exports__